var _excluded = ["text"],
  _excluded2 = ["children", "className", "hasBorder", "icon", "iconAlt", "isSelectable", "title", "headingLevel", "subtitle", "actionButton", "variant", "label", "aside", "inputProps", "utils"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from 'react';
import InverseContext from '../../../../utilities/inverse-context';
import PropTypes from 'prop-types';
import StyledTileHead from './tile.head.styles';
import StyledTileActionButton from '../../styles/tile.actionbutton.styles';
import StyledTileDivider from '../../styles/tile.divider.styles';
import StyledTileOuter from '../../styles/tile.outer.styles';
import StyledTileInner from '../../styles/tile.inner.styles';
import StyledTileLabel from '../../styles/tile.label.styles';
import StyledTileIcon from '../../styles/tile.icon.styles';
import StyledTileTitle from '../../styles/tile.title.styles';
import Divider from '../../../divider';
import Button from '../../../button/Button';
import FormOption from '../../../form-option';
import Type from '../../../type';
import Icon from '../../../icon';
import { TileContext } from '../../tile-context';
import withDeprecatedProps from '../../../../utilities/with-deprecated-props/withDeprecatedProps';
import useTile from '../../tile.hook';
var tileHeadPropTypes = {
  /**
   * Take control with child elements. This overwrites title and subtitle
   */
  children: PropTypes.node,
  /** additional classes */
  className: PropTypes.string,
  /** Adds a divider to the bottom */
  hasBorder: PropTypes.bool,
  /**
   * @deprecated since 2.55.0
   * @see hasBorder
   */
  isBordered: PropTypes.bool,
  /** Renders a specific icon . */
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Alternative text used to set the icon SVG title */
  iconAlt: PropTypes.string,
  /** Places child elements flush to the edges */
  isFlush: PropTypes.bool,
  /** Renders a checkbox for the Tile */
  isSelectable: PropTypes.bool,
  /** Padding for Header  */
  density: PropTypes.oneOf(['comfortable', 'compact']),
  /** Tile Header background color */
  variant: PropTypes.oneOf(['default', 'gray', 'cool-gray', 'white', 'dark', 'brand', 'transparent']),
  /** Add a pre-formatted title */
  title: PropTypes.node,
  /** Semantic Heading Level of the title */
  headingLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  /** Add a pre-formatted sub-title */
  subtitle: PropTypes.node,
  /** Add a label */
  label: PropTypes.node,
  /** Add aside which could be used for additional child elements  */
  aside: PropTypes.node,
  /** Add action button to the head */
  actionButton: PropTypes.shape({
    /** Button text */
    text: PropTypes.node
  }),
  /** Allow devs to control the checked status of the checkbox  */
  inputProps: PropTypes.object,
  /** Add utility objects for styling */
  utils: PropTypes.object
};
var tileHeadDefaultProps = {
  children: null,
  className: '',
  hasBorder: true,
  icon: null,
  iconAlt: '',
  isBordered: null,
  isFlush: false,
  isSelectable: false,
  density: 'comfortable',
  variant: 'default',
  title: 'Tile title',
  headingLevel: null,
  subtitle: '',
  label: '',
  aside: null,
  actionButton: null,
  inputProps: {},
  utils: {}
};
function renderActionButton(_ref) {
  var text = _ref.text,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Button, _extends({}, other, {
    shape: "pill"
  }), text);
}
var renderChildren = function renderChildren(_ref2) {
  var children = _ref2.children,
    useIsInverse = _ref2.useIsInverse,
    variant = _ref2.variant;
  return /*#__PURE__*/React.createElement(InverseContext.Provider, {
    value: variant === 'brand' || variant === 'dark' || variant === 'default' && useIsInverse
  }, children);
};
var TileHead = function TileHead(_ref3) {
  var children = _ref3.children,
    className = _ref3.className,
    hasBorder = _ref3.hasBorder,
    icon = _ref3.icon,
    iconAlt = _ref3.iconAlt,
    isSelectable = _ref3.isSelectable,
    title = _ref3.title,
    headingLevel = _ref3.headingLevel,
    subtitle = _ref3.subtitle,
    actionButton = _ref3.actionButton,
    variantProp = _ref3.variant,
    label = _ref3.label,
    aside = _ref3.aside,
    inputProps = _ref3.inputProps,
    utils = _ref3.utils,
    other = _objectWithoutProperties(_ref3, _excluded2);
  // Use inherited variant from Tile parent if Tile.Header variant is 'default'.
  var _useTile = useTile(TileContext, {
      variant: variantProp
    }),
    isLastChild = _useTile.isLastChild,
    onRefSet = _useTile.onRefSet,
    tileSize = _useTile.tileSize,
    variant = _useTile.variant;
  var useIsInverse = useContext(InverseContext);
  var renderIconProp = function renderIconProp() {
    return _typeof(icon) === ('string' || Object) ? /*#__PURE__*/React.createElement(Icon, {
      icon: icon,
      size: 1,
      alt: iconAlt
    }) : icon;
  };
  var hasIcon = icon && /*#__PURE__*/React.createElement(StyledTileIcon, null, renderIconProp());
  var hasTitle = /*#__PURE__*/React.createElement(StyledTileTitle, null, label && /*#__PURE__*/React.createElement(StyledTileLabel, null, label), /*#__PURE__*/React.createElement(Type, {
    element: headingLevel && "h".concat(headingLevel),
    size: "md",
    variant: "inherit",
    weight: "semibold",
    lineHeight: "md"
  }, title), /*#__PURE__*/React.createElement(Type, {
    element: "span",
    size: "sm",
    lineHeight: "sm",
    weight: "normal",
    variant: "inherit"
  }, subtitle));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTileHead, _extends({}, other, {
    ref: onRefSet,
    className: className,
    containersize: tileSize,
    utils: utils,
    variant: variant
  }), children ? renderChildren({
    children: children,
    useIsInverse: useIsInverse,
    variant: variant
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTileOuter, null, /*#__PURE__*/React.createElement(StyledTileInner, null, isSelectable ? /*#__PURE__*/React.createElement(FormOption, _extends({
    type: "checkbox"
  }, inputProps), hasIcon, hasTitle) : /*#__PURE__*/React.createElement(React.Fragment, null, hasIcon, hasTitle)), /*#__PURE__*/React.createElement(StyledTileActionButton, null, actionButton && renderActionButton(actionButton))), aside && /*#__PURE__*/React.createElement(React.Fragment, null, aside))), hasBorder && !isLastChild && /*#__PURE__*/React.createElement(StyledTileDivider, null, /*#__PURE__*/React.createElement(Divider, {
    isOffset: true
  })));
};
TileHead.defaultProps = tileHeadDefaultProps;
TileHead.propTypes = tileHeadPropTypes;
TileHead.displayName = 'Tile.Head';

/**
 * @type React.FC<tileHeadPropTypes>
 */
export default withDeprecatedProps(TileHead);